module.exports = __webpack_public_path__ + "static/media/points.9fc37560.png";